import React from 'react';
import styled from 'styled-components';
import {
  breakpointSizes,
  minBreakpointQuery,
  sectionPaddings,
  standardColours,
  brandColours,
  brandFonts,
  fontWeights,
  fontSize,
  fluidFontSize,
} from '../styles';
import { Container, Wave } from './ui';

const StyledHighlightedText = styled.section`
  ${sectionPaddings(undefined, '70px')};
  text-align: center;
  background-color: ${brandColours.primary};
`;

const StyledHeading = styled.h2`
  color: ${standardColours.white};
  font-weight: ${fontWeights.light};
  ${fontSize(18)};

  ${minBreakpointQuery.medium`
    ${fontSize(20)};
  `}
`;

const StyledWave = styled(Wave)`
  margin: 30px 0 20px;
  stroke: ${standardColours.white};
`;

const StyledText = styled.p`
  color: ${standardColours.white};
  font-family: ${brandFonts.secondary};
  font-weight: ${fontWeights.regular};
  ${fluidFontSize('28px', '50px', breakpointSizes.tiny, breakpointSizes.large)};
  line-height: 1.4;
`;

const HighlightedText = ({ heading, text }) => (
  <StyledHighlightedText>
    <Container narrow={true}>
      <StyledHeading>{heading}</StyledHeading>
      <StyledWave />
      <StyledText>{text}</StyledText>
    </Container>
  </StyledHighlightedText>
);

export default HighlightedText;
